import { createFileRoute } from '@tanstack/react-router';
import { AdminNotificationEditRoute } from '@/pages/admin-notifications/edit-route';

/** Modifica dei testi sopra la lista: `edit/$id`, come accessi e commercialisti. */
export const Route = createFileRoute(
  '/admin/_layout/notifications/_layout/edit/$id'
)({
  component: AdminNotificationEditRouteComponent,
});

function AdminNotificationEditRouteComponent() {
  const { id } = Route.useParams();

  return <AdminNotificationEditRoute id={id} />;
}
